import { accountSettingsSchema } from "@fapinstructor/common";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { fapinstructorApi } from "../../api";

async function getAccountSettings() {
  return await fapinstructorApi
    .get("/account/settings")
    .json(accountSettingsSchema);
}

export function useAccountSettings() {
  const query = useQuery(accountSettingsQueryOptions());
  return query;
}

export const accountSettingsQueryOptions = () =>
  queryOptions({
    queryKey: ["account", "settings"],
    queryFn: () => getAccountSettings(),
    throwOnError: true,
  });
